import React from 'react'
import { Link } from 'react-router-dom'
import { removeDuplicateClasses } from './PrimaryButton'

const OutlineButton = ({
  children,
  to,
  href,
  onClick,
  disabled = false,
  className = '',
  ...props
}) => {
  const baseClasses =
    'h-[50px] text-center font-bold py-2 px-4 gap-2 rounded flex justify-center items-center'
  const activeClass =
    'bg-white hover:text-primary-600 hover:border-primary-600 focus:border-primary-700 focus:text-primary-700 border border-solid border-primary-500 text-primary-500'
  const disableClass =
    'bg-white text-primary-200 border border-solid border-primary-200'
  const combinedClasses = removeDuplicateClasses(
    `${disabled ? disableClass : activeClass} ${baseClasses}`,
    className
  )

  if (to) {
    return (
      <Link to={to} className={combinedClasses} {...props}>
        {children}
      </Link>
    )
  } else if (href) {
    return (
      <a href={href} target="_blank" className={combinedClasses} {...props}>
        {children}
      </a>
    )
  }

  return (
    <button
      onClick={onClick}
      className={combinedClasses}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default OutlineButton
